import { Injectable } from '@angular/core';
import CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  private secretKey: string = 'd+b//jT8gaUAqpj+QIDCmhYoMHOlxp9jH9e3QZob0PvNBpwnJhovoEQYlvsDy6+x';

  public saveData(key: string, value: string, storage = localStorage): void {
    storage?.setItem(key, this.encrypt(value));
  }

  public getData(key: string, storage = localStorage): string | null {
    let data = storage?.getItem(key) || '';
    return this.decrypt(data) || null;
  }

  public removeData(key: string, storage = localStorage): void {
    storage.removeItem(key);
  }

  public clearData(storage = localStorage): void {
    storage.clear();
  }

  private encrypt(txt: string): string {
    return CryptoJS.AES.encrypt(txt, this.secretKey).toString();
  }

  private decrypt(txtToDecrypt: string): string {
    return CryptoJS.AES.decrypt(txtToDecrypt, this.secretKey).toString(CryptoJS.enc.Utf8);
  }
}
